import { HttpErrorResponse } from '@angular/common/http';

export class FetchUsersReportDetailsFailure {
    static readonly type = '[User] FetchUsersReportDetailsFailure';

    constructor(
        public payload: {
            response: HttpErrorResponse;
        }
    ) {}
}
